// Entry point for the build script in your package.json
import '@hotwired/turbo-rails'
import './controllers'
import 'flowbite/dist/flowbite.turbo.js'
import Sortable from 'sortablejs'
import Choices from 'choices.js'

window.addEventListener('turbo:load', () => {
  const buttons = document.querySelectorAll('.dialog')
  for (let i = 0; i < buttons.length; i++) {
    const button = buttons[i]
    const targetId = button.getAttribute('target')
    const target = document.getElementById(targetId)
    button.addEventListener('click', () => {
      target.showModal()
    })
  }
})

window.addEventListener('turbo:load', () => {
  document.addEventListener('turbo:submit-end', (event) => {
    if (event.detail.success) {
      const form = event.detail.formSubmission.formElement
      const dialog = form.closest('dialog')
      if (dialog) {
        dialog.close()
      }
    }
  })
})

window.addEventListener('turbo:load', () => {
  const sortables = document.querySelectorAll('.sortable')
  for (let i = 0; i < sortables.length; i++) {
    const sortable = sortables[i]
    Sortable.create(sortable, {
      animation: 150,
      dragClass: '!rounded-none',
      onUpdate: (event) => {
        const items = event.from.children
        let j = 1
        for (let i = 0; i < items.length; i++) {
          const input = items[i].querySelector("input[id*='position']")
          if (input) {
            input.value = j
            j += 1
          }
        }
        sortable.closest('form').requestSubmit()
      }
    })
  }
})
window.addEventListener('turbo:load', () => {
  window.Choices = Choices
})
